import { Button } from 'components/atoms';
import { Form } from 'components/organisms';
import { merchInitialValues } from 'components/organisms/forms/merch/MerchForm';
import { FormikHelpers } from 'formik';
import { useMutateOptions } from 'hooks';
import middleware from 'middleware';
import { useTranslation } from 'react-i18next';
import { PiShoppingBag, PiX } from 'react-icons/pi';
import { useLocation, useNavigate } from 'react-router-dom';
import { usePostMerch } from 'services/merch';
import { useAddMerchImage } from 'services/merch/images';
import { IMerchMutationForm, IMerchResponse } from 'services/merch/types';
import { BUTTON_VARIANT } from 'types/components/button/button.interface';
import { onErrorShowAllErrorsToast } from 'utils/service/errorHandler';

const CreateMerch = () => {
  const createMerch = usePostMerch();
  const addImage = useAddMerchImage();

  const { t } = useTranslation();

  const navigate = useNavigate();
  const { pathname } = useLocation();

  const mutateOptions = useMutateOptions<IMerchMutationForm>();

  const onCreateImage = async (
    merchId: string,
    croppedFile: File,
    clearAllValues?: () => void
  ) => {
    await addImage.mutateAsync(
      { file: croppedFile, id: merchId, isMain: true },
      {
        onSuccess: async () => {
          clearAllValues && clearAllValues();
        },
        onError: error => onErrorShowAllErrorsToast(error),
      }
    );
  };

  const handleImagesAfterCreate = async (
    merchId: string,
    values: IMerchMutationForm
  ) => {
    try {
      if (values.gallery.pendingImages?.length) {
        await Promise.all(
          values.gallery.pendingImages.map(async croppedFile => {
            try {
              await onCreateImage(merchId, croppedFile);
            } catch (error) {
              console.error('Błąd podczas dodawania obrazu:', error);
            }
          })
        );
      }
    } catch (error) {
      console.error(
        'Błąd podczas przetwarzania obrazów po utworzeniu merchu:',
        error
      );
    }
  };

  const onSuccessCreateMerch = async (
    data: IMerchResponse,
    values: IMerchMutationForm
  ) => {
    await handleImagesAfterCreate(data.id, values);
    navigate(`/merch/${data.id}/data`);
  };

  const onCreateMerch = async (
    values: IMerchMutationForm,
    helpers: FormikHelpers<IMerchMutationForm>
  ) => {
    try {
      const merch = middleware.merch.formToQuery(values);

      await createMerch.mutateAsync(merch, {
        ...mutateOptions(helpers),
        onSuccess: async data => {
          await onSuccessCreateMerch(data, values);
        },
      });
    } catch (error) {
      console.error('Błąd podczas tworzenia merchu:', error);
    }
  };

  return (
    <Form.Merch
      i18nextPrefix='merch'
      initialValues={merchInitialValues}
      onSubmit={onCreateMerch}
      customBackItem={
        <Button
          type='button'
          isClear
          onlyIcon
          onClick={() => navigate('/merch')}>
          <Button.Icon icon={<PiX />} />
        </Button>
      }
   
    />
  );
};

export default CreateMerch;
